<template>
	<div id="app" class="app" :class="{'is-profile' : $route.path.includes('/profile/')}">
		<migration-banner v-if="showMigrationBanner"/>

		<div class="wrapper" v-if="setting && config">
			<widget-host placement="global"/>
			<transition name="component-fade" mode="out-in">
				<router-view/>
			</transition>
		</div>
		
		<hidden/>
		
		<div class="global-loader" v-show="globalLoader || !translations">
			<loader color="black"/>
		</div>
		
		<portal-target name="fullscreen-video-teleport"></portal-target>
	</div>
</template>

<style src="@/assets/scss/main.scss" lang="scss"></style>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import store from '@/store/'
import Hidden from '@/components/features/hidden/index.vue';
import MigrationBanner from '@/components/features/migration-banner/index.vue';
import WidgetHost from '@/components/features/widget-host/index.vue';
import {isMobile} from '@/helpers/variables/index'
import {translationUtils} from "@/utils/translations";

export default {
	name        : 'app',
	components  : {
		Hidden,
		MigrationBanner,
		'widget-host': WidgetHost
	},
	computed    : {
		...mapGetters({
			globalLoader    : 'system/globalLoader',
			config          : 'setting/config',
			setting         : 'setting/setting',
			isAuthenticated : 'auth/isAuthenticated',
			translations    : 'setting/translations',
			currentCountry  : 'setting/currentCountry',
			defaultLocale   : 'setting/defaultLocale',
			user            : 'user/user'
		}),
		// Migration-invite banner: only on the authenticated cabinet, never on
		// the marketing home route (which has no header/cabinet chrome).
		showMigrationBanner() {
			return this.isAuthenticated && this.$route.name !== 'home';
		}
	},
	beforeCreate() {
		if (this.$route.query.hasOwnProperty('user_token') && this.$route.query.hasOwnProperty('user_refresh') && this.$route.query.hasOwnProperty('session-id')) {
			for (let i in this.$route.query) {
				if (i === 'user_token') {
					store.dispatch('auth/AUTH_SET_TOKEN', {token: this.$route.query[i], type: 'authorization'});
					
					continue;
				}
				
				if (i === 'user_refresh') {
					store.dispatch('auth/AUTH_SET_TOKEN', {token: this.$route.query[i], type: 'refresh'});
					
					continue;
				}
				
				localStorage.setItem(i, this.$route.query[i])
			}
		}
	},
	created() {
		if (!localStorage.hasOwnProperty('countryId')) {
			localStorage.setItem('countryId', '242')
		}
		
		if (!this.isAuthenticated && this.$route.name === 'auth') {
			this.$router.push({name: 'sing-in'})
		}
		
		if (this.isAuthenticated && this.$route.name === 'auth') {
			this.$router.push({name: 'courses'})
		} else if (!this.isAuthenticated && this.$route.name === 'auth') {
			this.$router.push({name: 'sing-in'})
		}
		
		let promises = [
			this.fetchCountry({id: 242}),
			this.fetchSetting()
		];
		
		if (this.isAuthenticated) {
			promises.push(this.fetchUser())
		}
		
		Promise.all(promises)
		.then(() => {
			this.setLocale();
			
			if(this.setting.widgets) {
				this.setting.widgets.forEach((item)=>{
					const docFragment = document.createElement("div");
					
					docFragment.innerHTML = item;
					document.body.appendChild(docFragment);
				})
			}
		})
		.catch(e => {
			console.log(e);
			
			this.$toasted.error('set interface locale error');
		});
		
		if (this.$route.fullPath.includes('setNewPassword')) {
			this.changePopupNewPassword(true);
		}
	},
	mounted() {
		if (!isMobile.any()) {
			document.querySelector('body').classList.add('hover')
		}
	},
	watch	: {
		user: {
			immediate: true,
			handler (user) {
				//console.log('user:', user);
				
				//return;
				
				if (
					process.env.NODE_ENV != 'production'
				) {
					if(user){
						GeniusAI.init({
							userId : user.id
						});
					}else{
						GeniusAI.destroy();
					}
				}
			}
		}
	},
	methods	: {
		setLocale() {
			let locale = this.defaultLocale.locale;
			
			if (this.user) {
				locale = this.user.languageInterface.value;
			}
			
			translationUtils.setInterfaceLanguage(locale)
		},
		...mapMutations({
			changePopupNewPassword: `auth/AUTH_SHOW_POPUP_NEW_PASSWORD`,
		}),
		...mapActions({
			fetchUser       : `user/GET_USER_DATA`,
			fetchConfig     : `setting/GET_CONFIG`,
			fetchCountry    : `setting/GET_COUNTRY`,
			fetchSetting    : `setting/GET_SETTING`,
		}),
	}
}
</script>
